import UnfilledButton from "@/components/common/unfilled-button";
import Link from "next/link";

interface UpgradeButtonProps {
  widthPercent?: number;
  onClick?: () => void;
}

const UpgradeButton = ({ widthPercent, onClick }: UpgradeButtonProps) => {
  return (
    <Link href={"/pricing"} style={{ width: `${widthPercent ?? 100}%` }}>
      <UnfilledButton
        text={"Upgrade"}
        borderColor={"#F9A825"}
        onClick={onClick}
      />
    </Link>
  );
};

export default UpgradeButton;
